import script from "./SupremaView.vue?vue&type=script&setup=true&lang=js"
export * from "./SupremaView.vue?vue&type=script&setup=true&lang=js"

import "./SupremaView.vue?vue&type=style&index=0&id=ee6ea04e&lang=css"

const __exports__ = script;

export default __exports__